module.exports = __webpack_public_path__ + "img/image-02.8e3fed4b.webp";